module.exports = __webpack_public_path__ + "img/男鞋1.b7e6bce5.png";